import { ProviderMedicalRole } from '@uplift/types';
import { UpliftLicenseType } from '@uplift/api';


export function getProviderLabelByMedicalRoleAndPrescriberTypes(
  providerMedicalRole: ProviderMedicalRole,
  providerPrescriberTypes: UpliftLicenseType[]
) {
  if (
    providerMedicalRole === ProviderMedicalRole.psychiatrist
    && providerPrescriberTypes?.some(pt => pt === 'psych_nurse_practitioner')
  ) {
    return 'Psych NP';
  }

  if (providerMedicalRole === ProviderMedicalRole.psychiatrist) {
    return 'Psychiatrist';
  }

  if (providerMedicalRole === ProviderMedicalRole.therapist) {
    return 'Therapist';
  }

  return '';
}
